import { Datepicker } from 'components/form/Datepicker';
import { DisplayModal } from 'components/modals';
import { Toaster } from 'components/notification/Toaster';
import { func_validation } from 'functions';
import React, { useEffect, useState } from 'react';

export function useRemarksModal({ billingSetupRemarks }) {
    const [isModalVisible_remarks, setIsModalVisible_remarks] = useState(false);
    const [accountCode, setAccountCode] = useState();

    let remarksModal = (
        <DisplayModal
            className={"recursiveBillingSetup__remarks-modal"}
            description={"Account Code " + accountCode}
            
            input={(
                <div className={"remarks-modal__wrapper"}>
                    {billingSetupRemarks? (
                        <>
                            <div className={"remarks-modal__header"}>Remarks</div>
                            <div className={"remarks-modal__description"}>{billingSetupRemarks}</div>
                        </>
                    ):"No Remarks"}
                </div>
            )}

            cancelButtonText={"Close"}
            isModalVisible={isModalVisible_remarks}
            updateParentState={setIsModalVisible_remarks}
        />
    );
    
    return {
        setAccountCode, setIsModalVisible_remarks,
        remarksModal
    }
}